import React, { Component } from "react";
import _ from "lodash";
import { withRedux } from "../hoc";
import { DetailPageLayout } from "../components";

const mapStateToProps = ({ language, t, posts, newsPage }) => {
  const data = _.get(posts, "data");
  const news = _.filter(data, item => {
    const categoryID = _.get(item, "category.id");
    return categoryID === _.toNumber(process.env.REACT_APP_POST_NEWS_ID);
  });

  const orderNews = _.sortBy(news, "updated_at");

  return {
    language,
    t,
    news: orderNews,
    newsPage: _.get(newsPage, "data")
  };
};

@withRedux(mapStateToProps)
export default class NewsDetail extends Component {
  render() {
    const id = this.props.match.params.id;
    const { news, newsPage } = this.props;
    const video = _.get(newsPage, "video");
    const imageBanner = _.get(newsPage, "imageBanner");
    const imageBannerMobile = _.get(newsPage, "imageBannerMobile");

    return (
      <DetailPageLayout
        data={news}
        id={_.toInteger(id)}
        path="news/detail"
        pageName="NEWS"
        page="news"
        media={video}
        imageBanner={imageBanner}
        imageBannerMobile={imageBannerMobile}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/NewsDetail.js